import axios, { AxiosResponse } from "axios";

import { LocalStorageService } from "../services/LocalStorageService";
import { LogoutPage } from "../pages";

// export const baseURL = "http://192.168.1.4:8502/";
// export const baseURL = "http://192.168.1.4:8802";
// export const baseURL = "http://192.168.1.4:8402";
// export const baseURL = "http://localhost:8200/";
export const baseURL = "https://swv3.taxslips.com/"; //for live build
// "homepage": "https://appv3.taxslips.com/",      //this will paste on package.json file

const http = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "POST, GET, OPTIONS, PUT, DELETE",
    "Access-Control-Allow-Headers":
      "Context-Type, X-Auth-Token, Origin, Authorization",
  },
});

http.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    // Remove both possible casings of Content-Type
    delete config.headers["Content-Type"];
    delete config.headers["Content-type"];
  } else {
    config.headers["Content-Type"] = "application/json";
  }

  config.headers["Access-Control-Allow-Origin"] = "*";
  return config;
});

const requestHandler = (request: any) => {
  request.headers[
    "Authorization"
  ] = `Bearer ${LocalStorageService.getUserToken()}`;
  return request;
};

const responseSuccessHandler = (response: AxiosResponse<never>) => {
  return response;
};

const responseErrorHandler = (error: { response: { status: number } }) => {
  if (
    error.response &&
    error.response.status === 401 &&
    window.location.href.includes("/login")
  ) {
    return Promise.resolve(error.response);
  } else if (
    error.response &&
    (error.response.status === 401 || error.response.status === 403)
  ) {
    // AuthService.signOut();
    // window.location.href = "/";
    //window.location.reload();
    // LogoutPage()
    localStorage.clear();
    // window.location.href = "/taxslips_v6.com/"; //for local server build
    window.location.href = "/"; //for app.live build
    // window.location.href = "/"; //for app.live build
  } else if (error.response && error.response.status === 400) {
    return error.response;
  }

  return Promise.reject(error);
};

http.interceptors.request.use(
  (request: any) => requestHandler(request),
  (error: any) => console.error("error =>", error)
);

http.interceptors.response.use(
  (response: any) => responseSuccessHandler(response),
  (error: any) => responseErrorHandler(error)
);

export default http;
